import { STATIC_MENU_ITEM } from '$layouts/LayoutWithSidebar/constants'
import {
  menuContainer,
  menuLinksContainer,
  menuSubContainer
} from '$layouts/LayoutWithSidebar/styles.css'
import { trueOrUndefined } from '@genie-fintech/ui/functions'
import {
  container,
  icon,
  indicator,
  linkName,
  subContainer
} from '$components/MenuLink/styles.css'

type Props = {
  menus: STATIC_MENU_ITEM[]
  selectedMenu: string
  onMenuClick?: (menu: string) => void
}

type MenuItemsProps = {
  menu: STATIC_MENU_ITEM
  selectedMenu: string
  onMenuClick?: (menu: string) => void
}
const MenuItems = ({ menu, selectedMenu, onMenuClick }: MenuItemsProps) => {
  const { name: menuName, path, Icon } = menu

  const active = path === selectedMenu

  return (
    <article className={container} data-active={trueOrUndefined(active)}>
      <a
        className={subContainer}
        style={{
          width: '100%',
          justifyContent: 'flex-start',
          cursor: 'pointer'
        }}
        onClick={() => onMenuClick && onMenuClick(path)}
      >
        <Icon size={20} className={icon} />
        <span className={linkName({ active })}>{menuName}</span>
      </a>

      <span className={indicator} />
    </article>
  )
}

export const AssignRolesSidebar = ({
  menus,
  selectedMenu,
  onMenuClick
}: Props) => {
  return (
    <aside className={menuContainer}>
      <article className={menuSubContainer}>
        <div className={menuLinksContainer}>
          {menus.map(menu => (
            <MenuItems
              key={menu.name}
              menu={menu}
              selectedMenu={selectedMenu}
              onMenuClick={onMenuClick}
            />
          ))}
        </div>
      </article>
    </aside>
  )
}
